import styles from './descriptionblock.module.css';

interface IDescriptionBlockProps {
    children: React.ReactNode
}

export function DescriptionBlock({ children }: IDescriptionBlockProps) {
    return (
        <div className={styles.description}>
            {children}
        </div>
    )
}